// The short form of an id a reader cannot resolve to a name (design-system
// §3.9). `RefLabel` prints it in its unresolved chip, and a screen that has no
// name for a reference prints it the same way.
//
// WHY THE TAIL. Every id this product mints is a uuid v7, whose first twelve
// hex characters are the millisecond it was made. Two records made in the same
// minute share their first eight characters, so a column of "019e38ce" chips
// told a reader nothing, and the owner's guide screenshots showed exactly that.
// The last group of a v7 is random, so its last eight characters tell two ids
// apart, and they are what a support thread can quote and search for.
//
// Only a uuid-shaped id is cut. A natural key (an audit row's `entity_id` is
// one for two writers) is shown whole, because a slice of it names nothing.

/** 8-4-4-4-12, the shape every uuid (v4 or v7) takes. Loose on the alphabet so
 * a test fixture's readable tail (`…00000000p001`) is still read as an id. */
const UUID_SHAPE = /^[0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12}$/iu;

/** How many characters of the random tail the chip shows. */
export const SHORT_ID_LENGTH = 8;

/** True for a value shaped like a uuid. */
export function isUuidShaped(value: string): boolean {
  return UUID_SHAPE.test(value);
}

/** The last eight characters of a uuid, or any other key whole. */
export function shortId(id: string): string {
  return isUuidShaped(id) ? id.slice(-SHORT_ID_LENGTH) : id;
}
